import { createEvent, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'
import { SendRequestToChatPayload } from './types'

export const sendRequestToChat = createEvent<SendRequestToChatPayload>()

export const sendRequestToChatFx = fx<SendRequestToChatPayload, void>({
  method: 'POST',
  url: '/verification/send-request-to-chat',
})

export const $sendRequestToChatPending = sendRequestToChatFx.pending

sample({
  clock: sendRequestToChat,
  fn: (payload) => ({
    body: payload,
  }),
  target: sendRequestToChatFx,
})

sample({
  clock: sendRequestToChatFx.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: sendRequestToChatFx.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})
